// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".results-paginated .pagination{margin:20px 0;flex-wrap:wrap;justify-content:center}\n", ""]);
// Exports
module.exports = exports;
